import styles from './Card.module.css';

export function Card({ children, className = '', padded = true, ...rest }) {
  return (
    <section className={`${styles.card} ${padded ? styles.padded : ''} ${className}`} {...rest}>
      {children}
    </section>
  );
}

export function CardHeader({ title, subtitle, action }) {
  return (
    <div className={styles.header}>
      <div>
        <h3 className={styles.title}>{title}</h3>
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export default Card;
